module.exports = __webpack_public_path__ + "static/desktop@2x-ac667bf6a7d723be4ef29f25a6792617.jpg";